import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const SuccessModal = () => {
  const [showModal, setShowModal] = useState(true);
  let navigate = useNavigate();

  const handleClose = () => {
    setShowModal(false);
    navigate("/account/fs-dashboard/my-account");
  };

  return (
    <>
      {showModal && (
        <div className="agreement-success-modal-overlay">
          <div className="agreement-success-modal-content">
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="agreement-modal-success-icon"
            />
            <h2>Success!</h2>
            <p>Profile Section updated successfully.</p>
            <button
              className="agreement-modal-close-button"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SuccessModal;
